import React from 'react';

const FilterSelect = ({ value, onChange, options, placeholder = "TODOS" }) => {
    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="p-column-filter p-component"
                style={{
                    width: '100%',
                    height: '35px',
                    borderRadius: '8px',
                    border: '1px solid #001873',
                    padding: '0 24px 0 8px',
                    fontSize: '0.8rem',
                    fontWeight: 'bold',
                    color: '#495057',
                    backgroundColor: 'white',
                    cursor: 'pointer',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none',
                    textAlign: 'center',
                    textAlignLast: 'center'
                }}
            >
                <option value="">{placeholder}</option>
                {(options || []).map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label.toUpperCase()}
                    </option>
                ))}
            </select>
            <div style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
                color: '#001873',
                fontSize: '0.8rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <i className="pi pi-chevron-down"></i>
            </div>
        </div>
    );
};

export default FilterSelect;
